import React from 'react';
import { Button } from '../components/ui/button';
import { Card, CardContent } from '../components/ui/card';
import { ArrowLeft } from 'lucide-react';
import Footer from '../components/Footer';

const Impressum = () => {
  const navigateHome = () => {
    window.location.href = '/';
  };

  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <header className="bg-white shadow-md sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
          <div className="flex items-center justify-between">
            <img 
              src="/images/davinci-logo-new.png" 
              alt="Da Vinci Institut" 
              className="h-16 md:h-24 cursor-pointer"
              onClick={navigateHome}
            />
            <Button
              onClick={navigateHome}
              variant="outline"
              className="border-2 border-teal-600 text-teal-600 hover:bg-teal-50 rounded-full"
            >
              <ArrowLeft className="w-4 h-4 mr-2" />
              Zurück zur Startseite
            </Button>
          </div>
        </div>
      </header>

      {/* Content */}
      <section className="py-16 md:py-20 bg-gradient-to-br from-teal-50 via-white to-teal-50/30 relative">
        <div className="absolute top-20 left-0 w-72 h-72 bg-teal-100/40 rounded-full blur-3xl -translate-x-1/2"></div>
        <div className="absolute top-32 right-0 w-96 h-96 bg-teal-200/30 rounded-full blur-3xl translate-x-1/3"></div>
        
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-8 text-center">
            Impressum
          </h1>
          
          <Card className="border-gray-200 shadow-xl rounded-3xl overflow-hidden">
            <CardContent className="p-8 md:p-12 space-y-8">
              {/* Angaben gemäß § 5 DDG */}
              <div>
                <h2 className="text-2xl font-bold text-teal-700 mb-4">
                  Angaben gemäß § 5 DDG
                </h2>
                <div className="text-gray-700 leading-relaxed space-y-1">
                  <p className="font-semibold">Cem Kilic</p>
                  <p>handelnd unter: Da Vinci Institut</p>
                  <p>Quettinghofstraße 47C</p>
                  <p>50769 Köln</p>
                  <p>Deutschland</p>
                </div>
              </div>

              {/* Kontakt */}
              <div>
                <h2 className="text-2xl font-bold text-teal-700 mb-4">
                  Kontakt
                </h2>
                <div className="text-gray-700 leading-relaxed space-y-1">
                  <p>Telefon: <a href="tel:+4915216817165" className="text-teal-600 hover:text-teal-800 transition-colors">+49 152 16817165</a></p>
                  <p>E-Mail: <a href="mailto:info@davinci-institut.de" className="text-teal-600 hover:text-teal-800 transition-colors">info@davinci-institut.de</a></p>
                </div>
              </div>

              {/* Verantwortlich */}
              <div>
                <h2 className="text-2xl font-bold text-teal-700 mb-4">
                  Verantwortlich für den Inhalt nach § 18 Abs. 2 MStV
                </h2>
                <div className="text-gray-700 leading-relaxed space-y-1">
                  <p className="font-semibold">Cem Kilic</p>
                  <p>Quettinghofstraße 47C</p>
                  <p>50769 Köln</p>
                </div>
              </div>

              {/* Streitbeilegung */}
              <div>
                <h2 className="text-2xl font-bold text-teal-700 mb-4">
                  Verbraucherstreitbeilegung / Universalschlichtungsstelle
                </h2>
                <div className="text-gray-700 leading-relaxed">
                  <p>
                    Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren 
                    vor einer Verbraucherschlichtungsstelle teilzunehmen.
                  </p>
                </div>
              </div>
            </CardContent>
          </Card>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Impressum;
